<nx-pageTitle-box
  [bcRootLvlLabel]="'tourPlanningModule.toursDetailPageComponent.breadcrumb.tourPlanner' | translate"
  [bcRootLvlPath]="'/tour-planner'"
  class="mb-3"
  [label]="this.tour?.name"
  [icon]="'icon-tour'"
  [iconToolTip]="'tourPlanningModule.toursDetailPageComponent.tooltip.tour' | translate"
  [menuItems]="pageTitleMenuItems">
  <ng-template nxTemplate="tag">
    <p-tag class="mr-2" [value]="tour?.getStateLabel()" [severity]="tour?.getStateSeverity()"></p-tag>
  </ng-template>
</nx-pageTitle-box>
<div class="flex flex-row gap-4 h-[calc(100%-80px)]">
  <div #xScrollContainer class="flex-shrink-0 min-w-[500px] max-w-[570px] overflow-auto">
    <nx-headline-box 
      [label]="'tourPlanningModule.toursDetailPageComponent.section.tourData' | translate">
    </nx-headline-box>
    <div class="flex flex-row">
        <nx-default-box
        class="basis-1/2 bg-white border-b border-gray"
        [label]="'tourPlanningModule.toursDetailPageComponent.fields.driver' | translate">
        {{ tour?.driver?.firstName }} {{ tour?.driver?.lastName }}
      </nx-default-box>
      <nx-default-box
        class="basis-1/2  bg-white border-b border-gray"
        [label]="'tourPlanningModule.toursDetailPageComponent.fields.vehicle' | translate">
        {{ tour?.resource?.name }}
      </nx-default-box>
    </div>
    <div class="flex flex-row">
      <nx-default-box
        class="basis-1/2 bg-white border-b border-gray"
        [label]="'tourPlanningModule.toursDetailPageComponent.fields.location' | translate">
        {{ tour?.location?.name }}
      </nx-default-box>
      <nx-default-box
        class="basis-1/2 bg-white border-b border-gray"
        [label]="'tourPlanningModule.toursDetailPageComponent.fields.planningDate' | translate">
        {{ tour?.dateTimeReference | date:'dd.MM.yyyy' }}
      </nx-default-box>
    </div>
    <nx-default-box
      class="basis-1/2  bg-white border-b border-gray"
      [label]="'tourPlanningModule.toursDetailPageComponent.fields.tourNote' | translate">
      {{ tour?.note }}
    </nx-default-box>
    <div class="flex flex-row">
      <nx-default-box
        class="basis-1/2 bg-white border-b border-gray"
        [label]="'tourPlanningModule.toursDetailPageComponent.fields.distance' | translate">
        {{_sumDistance? (_sumDistance | number:'1.0-1') + ' km' : undefined }}
      </nx-default-box>
      <nx-default-box
        class="basis-1/2 bg-white border-b border-gray"
        [label]="'tourPlanningModule.toursDetailPageComponent.fields.travelTime' | translate">
        {{ _sumDuration?  (_sumDuration / 60 | number:'1.2-2') + ' h' : undefined}}
      </nx-default-box>
    </div>

    <nx-headline-box 
      class="mt-3"
      [label]="'tourPlanningModule.toursDetailPageComponent.section.route' | translate">
    </nx-headline-box>

    <div class="flex flex-row bg-white border-b border-gray">
      <div class="w-[26px] flex items-center place-content-center">
        <div class="text-base pl-1">A</div>
      </div>
      <span class="flex basis-1/3 items-center row pl-3 text-base">
        {{tour?.effectiveDepartureDateTime ? (tour?.effectiveDepartureDateTime | date:'HH:mm, dd.MM.')  : '--:--'}}
      </span>
      <div
        class="flex basis-2/3 items-center place-content-end pr-3 text-base">
       {{tour?.departureAddress?.getAddressString()? tour?.departureAddress?.getAddressString() : '–'}}
        </div>
    </div>

    <div
      *ngIf="tour?.tasks?.length > 0" 
      class="text-sm bg-white border-b border-gray">
      {{_route?.sections[0]?.summary?.length ? (_route?.sections[0]?.summary?.length / 1000 |
              number:'1.0-1') : '-'}} km / {{_route?.sections[0]?.summary?.baseDuration ? (_route?.sections[0]?.summary?.baseDuration / 60 | number:'1.0-0') : '-'}} min
    </div>

    <nx-empty-box *ngIf="!tour?.tasks || (tour?.tasks?.length === 0)"
      class="empty-box"
      [labelOverwriteClass]="'text-base font-light text-[#848488] px-5 py-2 bg-white border-b flex items-center justify-center h-[59px] min-w-[280px]'"
      [label]="'tourPlanningModule.toursDetailPageComponent.emptyState.noTasksPlanned' | translate"
      ></nx-empty-box>

    <div 
      nxDropList
      [nxDropListData]="tour"
      [nxIsDropDisabled]="true"
      [id]="'toursTaskList'"
      class="flex flex-col tasks">

        <div
          nxDragItem
          [nxDragItemIsDropTarget]="true"
          [nxIsDropDisabled]="isDropDisabled(tour)"
          [nxDragItemData]="task"
          [nxDragItemDropListIndex]="i"
          [nxDragItemDropListId]="tour?.id"
          [nxIsDragDisabled]="isDragDisabled(task)"
          (nxDragDropped)="dragDropped($event)"
          (nxDragStarted)="dragStarted($event)"
          (nxDragEnded)="dragReleased($event)"         
          *ngFor="let task of tour?.tasks; 
          let isFirst = first; 
          let isLast = last; 
          let i = index; 
          let c = count"
          class="flex flex-col task">
          
          <div class="taskRow flex task border-b">
            <div class="w-[26px] flex items-center place-content-center">
              <div class="letter">{{toLetters(i + 2 )}}</div>
            </div>
            <div
              task-row
              [showOrderNote]="true"
              [showCommandMenu]="task?.type === 'nexcore_default_task' && task?.commands?.length > 0"
              (refetchTasks)="refetch()"
              [task]=task
              class="flex flex-row basis-full items-center">
            </div>

          </div>

          <div class="text-sm bg-white border-b border-gray">
            {{_route?.sections[i+1]?.summary?.length ? (_route?.sections[i+1]?.summary?.length / 1000 |
                number:'1.0-1') : '-'}} km / {{_route?.sections[i+1]?.summary?.baseDuration ? (_route?.sections[i+1]?.summary?.baseDuration / 60 | number:'1.0-0') : '-'}} min
          </div>
        </div>

    </div>

    <div class="flex flex-row bg-white border-b border-gray">
      <div class="w-[26px] flex items-center place-content-center">
        <div class="text-base pl-1">{{toLetters(tour?.tasks?.length + 2 )}}</div>
      </div>
      <span class="flex basis-1/3 items-center row pl-3 text-base">
        {{tour?.effectiveArrivalDateTime ? (tour?.effectiveArrivalDateTime | date:'HH:mm, dd.MM. ') : '--:--'}}
      </span>
      <div
        class="flex basis-2/3 items-center place-content-end pr-3 text-base">
       {{tour?.arrivalAddress?.getAddressString()? tour?.arrivalAddress?.getAddressString() : '–'}}
        </div>
    </div>

  </div>
  <div class="flex-grow overflow-auto">
    <nx-headline-box
      [label]="'tourPlanningModule.toursDetailPageComponent.section.map' | translate">
    </nx-headline-box>
    <div class="flex basis-full map h-[calc(100%-48px)] bg-white p-4">
      <app-tours-detail-planning-map class="flex basis-full map h-full" [tour]="tour"
        (routeCalculated)=routeCalculated($event)>
      </app-tours-detail-planning-map>
    </div>
  </div>
</div>
